/**
 * Initial state split by slice concern.
 *
 * dataInitialState  — server-fetched data and its loading lifecycle.
 * interactionInitialState — transient user interaction state.
 */
import LoadingStatus from 'enums/loadingStatus';
import processMarkersPayload from '../services/processMarkers';

const initialSetElement = document.querySelector("[data-component='initial-markers-set']");
const initialResultsSet = initialSetElement ? JSON.parse(initialSetElement.innerHTML) : [];

export const dataInitialState = {
  fetchResultsStatus: LoadingStatus.Idle.toString(),
  fetchResultsError: null,
  results: processMarkersPayload(null, { communities: { CommunityResults: initialResultsSet } }),
  fetchSitePlansStatus: LoadingStatus.Idle.toString(),
  fetchSitePlansError: null,
  sitePlans: [],
  fetchBuildablePlansStatus: LoadingStatus.Idle.toString(),
  fetchBuildablePlansError: null,
  geoCoordinates: null,
};

export const interactionInitialState = {
  selectedMarker: null,
  markerCards: [],
  sitePlanCards: [],
};